import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchCoachOneTimeFeeThunk } from "../redux/Slices/onboardingSlice";
import { useSearchParams } from "react-router-dom";
import { Button } from "react-bootstrap";

const CoachOnboardSuccess = () => {
  const dispatch = useDispatch();
  const { coachOneTimeFee, loadingOneTimeFee, oneTimeFeeError } = useSelector(
    (state) => state.onboarding
  );

  const [searchParams] = useSearchParams();
  // The query key can arrive in different casings (e.g. "offerID" or "offerid")
  // after upstream redirects, so look it up case-insensitively.
  const offerID = (() => {
    for (const [key, value] of searchParams.entries()) {
      if (key.toLowerCase() === "offerid") return value;
    }
    return null;
  })();

  // Some redirects lowercase the query key. Normalize the browser URL back to
  // "offerID" without triggering a navigation/reload.
  useEffect(() => {
    if (!offerID) return;
    const params = new URLSearchParams(window.location.search);
    const keys = Array.from(params.keys());
    const hasExact = keys.includes("offerID");
    const wrongCaseKeys = keys.filter(
      (key) => key !== "offerID" && key.toLowerCase() === "offerid"
    );
    if (!hasExact || wrongCaseKeys.length) {
      wrongCaseKeys.forEach((key) => params.delete(key));
      params.set("offerID", offerID);
      window.history.replaceState(
        null,
        "",
        `${window.location.pathname}?${params.toString()}`
      );
    }
  }, [offerID]);

  useEffect(() => {
    if (coachOneTimeFee?.url) {
    //  console.log('test_coachOneTimeFee', coachOneTimeFee.url)
      window.location.href = coachOneTimeFee?.url;
    }
  }, [coachOneTimeFee]);

  const handlePayOneTimeFee = async () => {
    if (offerID) {
      dispatch(fetchCoachOneTimeFeeThunk({ offerID }));
    }
  };

  return (
    <div className=" formContainer d-flex justify-content-center align-items-center bg-light min-vh-100">
      <div className="w-100 p-4 p-md-5" style={{ maxWidth: "500px" }}>
        <div className="bg-white rounded-lg shadow-md p-4 p-md-5">
          <div className="text-center mb-4">
            <h2 className="text-2xl font-bold text-gray-800 mb-3">
              You're Almost Done! <br /> Complete Your One-Time Fee
            </h2>
            <p className="text-gray-600 mb-4">
              To activate your coaching account with RoarAI, please complete
              your one-time setup fee. You'll be securely redirected to Stripe
              to finish your payment.
            </p>
          </div>

          {oneTimeFeeError ? (
            <div className="alert alert-danger mb-2">{oneTimeFeeError}</div>
          ) : (
            <Button
              onClick={()=>{
              console.log('test_handlePayOneTimeFee')
                handlePayOneTimeFee()
              }}
              disabled={loadingOneTimeFee}
              className={`btn w-100 saveButton`}
            >
              {loadingOneTimeFee ? "Redirecting..." : "Pay Onetime Fee"}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default CoachOnboardSuccess;
